import { render, staticRenderFns } from "./Counsellor.vue?vue&type=template&id=cfd4e63a&scoped=true&"
import script from "./counsellor.js?vue&type=script&lang=js&"
export * from "./counsellor.js?vue&type=script&lang=js&"
import style0 from "./Counsellor.vue?vue&type=style&index=0&id=cfd4e63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd4e63a",
  null
  
)

export default component.exports